/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Premium_Types_TitleInputs */

const en_dialog_premium_types_title = /** @type {(inputs: Dialog_Premium_Types_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen to emails, MOBI, EPUB`)
};

const es_dialog_premium_types_title = /** @type {(inputs: Dialog_Premium_Types_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escucha correos, MOBI, EPUB`)
};

/**
* | output |
* | --- |
* | "Listen to emails, MOBI, EPUB" |
*
* @param {Dialog_Premium_Types_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_premium_types_title = /** @type {((inputs?: Dialog_Premium_Types_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Premium_Types_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_premium_types_title(inputs)
	return en_dialog_premium_types_title(inputs)
});